import Emoji from 'components/emojisPicker/models/emoji';
import { QuillBinding, QuillMatcher } from 'interfaces/quill';
import { DeltaStatic, Quill, RangeStatic } from 'libraries/quill';
import emojiPattern from 'patterns/emoji';
import { IChatEditorBlotInstance } from './iblot';

const emojione = require('emojione');

const asciiEmojiPattern = new RegExp(emojione.asciiRegexp);
const { asciiEmojiBlackList } = settings;

const parchment = Quill.import('parchment');
const Delta = Quill.import('delta');
const Keyboard = Quill.import('modules/keyboard');

function emojiMatcher(node: HTMLElement, delta: DeltaStatic) {
    let content = node.nodeValue ?? '',
        offset = 0;

    let match = emojiPattern.exec(content);

    while (match != null) {
        const shortName = match[0];
        const unicode = _(emojione.emojioneList[shortName]).last();

        if (unicode != undefined) {
            delta = delta.compose(new Delta()
                .retain(match.index + offset)
                .delete(shortName.length)
                .insert({ 'wcc-emoji': unicode }));

            offset += match.index + 1;
        } else {
            delta = delta.compose(new Delta()
                .retain(match.index + offset)
                .delete(shortName.length));

            offset += match.index;
        }

        content = content.slice(match.index + shortName.length);
        match = emojiPattern.exec(content);
    }

    return delta;
}

function handleAsciiEmoji(this: any, range: RangeStatic, context: any) {
    if (_.isEmpty(context.format)) {
        const asciiCode = _(context.prefix.trim().split(' ')).last();

        if (!_(asciiEmojiBlackList).contains(asciiCode)) {
            const unicode = _(emojione.asciiList).find((unicode: string, value: string) => value === asciiCode);
            const insertAt = range.index - asciiCode.length;

            if (unicode != undefined) {
                this.quill.deleteText(insertAt, range.index - insertAt);
                this.quill.insertEmbed(insertAt, 'wcc-emoji', unicode);
                this.quill.setSelection(insertAt + 1);

                return false;
            }
        }
    }

    return true;
}

function handleAsciiEmojiAndContinue(this: any, range: RangeStatic, context: any) {
    handleAsciiEmoji.call(this, range, context);
    return true;
}

const matchers: Array<QuillMatcher> = [
    [Node.TEXT_NODE, emojiMatcher]
]

const bindings: StringMap<QuillBinding> = {
    'handleAsciiEmoji': {
        key: ' ',
        collapsed: true,
        prefix: asciiEmojiPattern,
        handler: handleAsciiEmoji
    },

    'handleAsciiEmoji2': {
        key: Keyboard.keys.ENTER,
        collapsed: true,
        prefix: asciiEmojiPattern,
        handler: handleAsciiEmojiAndContinue
    }
}

export class ChatEditorEmojiBlot extends parchment.Embed implements IChatEditorBlotInstance {
    static blotName = 'wcc-emoji'
    static className = 'emoji';
    static tagName = 'img';
    static matchers = matchers;
    static bindings = bindings;

    unicode: string
    code: string

    constructor(node: HTMLImageElement, code: string) {
        super(node);
        
        this.unicode = code;
        this.code = _(emojione.emojioneList).findKey((codes: Array<string>) => codes.includes(this.unicode)) ?? '';
    }

    value() {
        return { 'emoji': this.unicode };
    }

    toString() {
        return this.code;
    }

    static create(unicode: string) {
        const emoji = new Emoji({ unicode: unicode });

        var node = super.create();
        node.src = emoji.url();

        return node;
    }

    static value(node: HTMLImageElement) {
        const url = node.src;
        const emoji = Emoji.fromURL(url);

        if (emoji != undefined)
            return emoji.code();
    }
}